const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

/**
 * Retrieves the authentication token from localStorage or cookie.
 */
export const getToken = () => {
  return localStorage.getItem('token') || getCookie('token');
};

/**
 * Retrieves the user object from localStorage or cookie.
 */
export const getUser = () => {
  const userStr = localStorage.getItem('user') || getCookie('user');
  if (userStr) {
    try {
      // Decode URL encoded cookie if necessary
      const decoded = decodeURIComponent(userStr);
      return JSON.parse(decoded);
    } catch (e) {
      console.error('Error parsing user data:', e);
      return null;
    }
  }
  return null;
};

/**
 * Saves both the token and user object to localStorage.
 */
export const setAuth = (token, user) => {
  localStorage.setItem('token', token);
  localStorage.setItem('user', JSON.stringify(user));
};

/**
 * Clears all authentication-related data.
 */
export const clearAuth = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  // Clear cookies as well
  const isProduction = window.location.hostname !== 'localhost';
  const domain = isProduction ? 'domain=.zaptude.com;' : 'domain=.localhost;';
  document.cookie = `token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; ${domain}`;
  document.cookie = `user=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; ${domain}`;
};
